import { defineStore } from "pinia";
const useProductAppPropsStore = defineStore("productAppPropsStore", {
  state: () => ({
    appProps: {}
  }),
  getters: {
    appPropsMap(state) {
      const { appProps } = state;
      return {
        abTestNames: state.appProps["frontend.abtest"],
        apiKeys: appProps["frontend.api.keys"],
        assets: appProps["frontend.static.assets"],
        devToggles: appProps["frontend.dev.toggles"],
        endpoints: appProps["frontend.endpoints"],
        launchToggles: appProps["frontend.launch.toggles"],
        recsPlacements: appProps["frontend.recommendations.placements"],
        scriptPaths: appProps["frontend.script.paths"],
        showPriceOfferMessages: appProps["frontend.priceOffer.toggles"],
        textStrings: appProps["frontend.strings"],
        triageToggles: appProps["frontend.triage.toggles"],
        mabcEarnPeriodToggle: appProps["frontend.mabc.enabled"]
      };
    }
  }
});
export {
  useProductAppPropsStore as default
};
//# sourceMappingURL=productAppPropsStore.mjs.map
